export default class IndirizziSpedizione{
    Cap;
    Citta;
    CodiceIndirizzo;
    Descrizione;
    Indirizzo;
    Provincia;
    constructor(){}
}